















import {
  ParentContent,
  SubjectiveContent,
} from '@/resource/question/question.type';
import { getSubjectiveOrder } from '@/utils/subjective-util';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {
    ComponentSubjective: () =>
      import(
        '@/components/questions/subjective-components/ComponentSubjective.vue'
      ),
  },
})
export default class SubjectiveParent extends Vue {
  @Prop({ required: true })
  content!: ParentContent;

  get contents() {
    return this.content.content as SubjectiveContent[];
  }

  get orderType() {
    return this.content.config.orderType;
  }

  get parentMargin() {
    return this.orderType ? `my-24 flex` : '';
  }

  getOrder(index: number) {
    if (this.orderType) {
      return getSubjectiveOrder(this.orderType, index);
    }
  }
}
